var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outline":"","small":_vm.sidebarStyle === 'portrait' || _vm.smallScreen,"color":"primary","disabled":_vm.interactionMeta.isProcessingData,"loading":_vm.interactionMeta.isProcessingData},on:{"click":function($event){$event.preventDefault();return _vm.resetInteraction()}}},[_vm._v(" Retry ")])
}
var staticRenderFns = []

export { render, staticRenderFns }